module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-INGE-V6-DUO.1968bc0c.png";